/* eslint-disable @nx/enforce-module-boundaries */

import { SearchIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Checkbox,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Text,
  VStack,
} from '@chakra-ui/react';
import { MyNetworkNewIcon } from '@mybridge/icons';

import { Avatar } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConnectionsData } from 'v4/store/actions/connection.actions';
import {
  CreateRoom,
  UpdateRoom,
  UpdateRoomInvited,
  UpdateRoomName,
  forwardMessage,
} from 'v4/store/actions/global.data.actions';

const ForwardMessage = ({
  refetchRoomsListing,
  isGroupModalOpen,
  setIsGroupModalOpen,
  connectionList,
  onSelectChat,
  isForwardMsgModal, 
  setIsForwardMsgModal,
  networkConnection, 
  setNetworkConnection,
  setRoomId,
  selectedForwardMsg,
  setSelectedForwardMsg,
  fetchRoomList,
  isCreateGroupedClicked,
  setIsCreateGroupedClicked,
  selectedChat,
  groupMemberDetail,
  roomId,
  isgroupNameModal,
  setIsgroupNameModal,
  setGroupName,
  groupName,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { userProfileInfo } = useSelector((state) => state.userProfile);

  /*
  useEffect(() => {
    dispatch(getConnectionsData()).then((res) => {
      setNetworkConnection(res?.payload?.results);
    });
  }, [connectionList]);
  */
  useEffect(() => {
    if (!isForwardMsgModal) return;
    dispatch(getConnectionsData()).then((res) => {
      setNetworkConnection(res?.payload?.results);
    });
  }, [isForwardMsgModal, connectionList]);

  const handleForwardMessage = () => {
    if (!selectedUsers.length || !selectedForwardMsg) {
  
      return;
    }
  
    // Extract message details
    const { msgtype, body, url, info } = selectedForwardMsg?.content;
  
    let message = {
      msgtype,
      info: info || {}, 
    };
  
  
    if (msgtype === "m.text") {
      message.body = body || "";
    } else if (["m.image", "m.video", "m.file","m.audio"].includes(msgtype)) {
      message.url = url || ""; 
      message.body = ""; 
    }
  
    // Iterate over selectedUsers and send the message to each user
    const sendMessages = selectedUsers.map((user) => {
      const roomId = user.room_id;
      return dispatch(forwardMessage({ roomId, message, eventId:selectedForwardMsg?.event_id }))
        .then((response) => {
          // console.log(`Message forwarded successfully to room ${roomId}:`, response);
        })
        .catch((error) => {
          console.error(`Error forwarding message to room ${roomId}:`, error);
        });
    });
  
    Promise.all(sendMessages)
      .then(() => {
        refetchRoomsListing?.();
        setIsForwardMsgModal(false); 
        setSelectedUsers([]); 
      })
      .catch((error) => {
        console.error("Error forwarding some messages:", error);
      });
  };
  



const handleCheckboxChange = (user) => {
  const isSelected = selectedUsers?.some(
    (selectedUser) => selectedUser?.user_details?.user_id === user?.user_details?.user_id
  );

  if (isSelected) {
    // Remove user from selected lists
    setSelectedUsers((prev) =>
      prev.filter(
        (selectedUser) =>
          selectedUser?.user_details?.user_id !== user?.user_details?.user_id
      )
    );
  } else {
    // Add user to selected lists
    setSelectedUsers((prev) => [...prev, user]);
  }
};

  const ForwardMessageUserList = connectionList?.filter((connection) =>
  networkConnection?.some(
    (user) => user?.id === connection?.user_details?.user_id  
  )
);

  // const filteredConnectionList = ForwardMessageUserList?.filter((user) =>
  //   user?.user?.user_details?.display_name?.toLowerCase().includes(searchTerm.toLowerCase())
  // );


  const handleRemoveSelectedUser = (id) => {
    const updatedUsers = selectedUsers.filter(
      (user) => user.matrix_user_id !== id
    );
    setSelectedUsers(updatedUsers);
  };


  return (
    <>
      <Modal
        isOpen={isForwardMsgModal}
        onClose={() => {
            setIsForwardMsgModal(false);
        }}
        height={'120px'}
      >
        {/* <ModalOverlay /> */}
        <ModalContent marginTop="150px">
          {/* <ModalCloseButton /> */}
          <ModalHeader>
            <HStack justifyContent="space-between">
              <Text
                fontFamily="Inter"
                fontSize="15px"
                fontWeight={600}
                lineHeight="18px"
                textAlign="left"
                textUnderlinePosition="from-font"
                textDecorationSkipInk="none"
                color="#5B5B5B"
              >
                {' '}
            {t('myMessages.forwardMessage') || "Forward Message"}
              </Text>
              <Button
                isDisabled={!selectedUsers?.length}
                width="57px"
                height="28px"
                padding="9px 18px 9px 18px"
                gap="10px"
                borderRadius="76px"
                bgColor={'#3D5A80'}
                fontFamily="Inter"
                fontSize="12px"
                fontWeight={500}
                lineHeight="14.4px"
                border="transparent"
                color="#ffffff"
                _hover={{
                  backgroundColor:'#3D5A80'
                }}
                onClick={()=>handleForwardMessage()}
              >
                {t('buttons.send') || "Send"}
              </Button>
            </HStack>
          </ModalHeader>
          <ModalBody>
            <HStack gap="10px" borderBottom="1px solid #E4E6EB" mb={3}>
              <SearchIcon w="18px" h="18px" />
              <Input
                placeholder="Search people"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                borderRadius="0px"
                border="unset"
                _focus={{
                  border: 'unset',
                }}
                backgroundColor="transparent"
              />
            </HStack>

            {/* Suggested Users */}
            <Text fontSize="sm" color="gray.500" mb={2}>
              {t('myMessages.suggested') || "Suggested"}
            </Text>
              <VStack
                align="stretch"
                spacing={4}
                overflow={'auto'}
                sx={{
                  '&::-webkit-scrollbar': {
                    width: '5px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#C8C8C8',
                    borderRadius: '51px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#555',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: '#EDEDED',
                  },
                }}
                height="45vh"
              >
                {ForwardMessageUserList?.map((user) => (
                  <HStack
                    key={user?.room_id}
                    justifyContent="space-between"
                    cursor="pointer"
                    pr={2}
                  >
                    <HStack spacing={3}>
                      <Avatar
                        src={user?.user_details?.avatar_url}
                        name={user?.user_details?.display_name}
                      />
                      <Box>
                        <Text fontWeight="bold" fontSize="sm">
                          {user?.user_details?.display_name}
                        </Text>
                        <Text fontSize="xs" color="gray.500">
                          {/* {user.title} */}
                        </Text>
                      </Box>
                    </HStack>
                    <Checkbox
                       isChecked={selectedUsers.some(
                        (selectedUser) =>
                          selectedUser.user_details.user_id === user.user_details.user_id
                      )}
                      onChange={() => handleCheckboxChange(user)}
                      borderRadius="full"
                      sx={{
                        '& span': {
                          borderRadius: '50%',
                          border: '1.5px solid #868585',
                          width: '18px',
                          height: '18px',
                        },
                        '& span[data-checked]': {
                          bg: '#3D5A80',
                          border: '1.5px solid #868585',
                        },
                        '& span[data-focus-visible]': {
                          boxShadow: 'unset',
                        },
                      }}
                    />
                  </HStack>
                ))}
              </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ForwardMessage;
